import React from 'react'
import { Button, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { Box, width } from '@mui/system'
import { useEffect, useState } from 'react'
import { Item } from '../../../../common/snippets'
import { connect } from 'react-redux'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import { updateAlertError, updateLoader, updateModal, } from '../../../../../store/common/common_action'
import Datepicker from '../../../../common/datePicker'
import DropDownOA from '../../../../common/dropDownOA'
import { isEmpty, removeDuplicatesFromArray } from '../../../../common/helper'
import { getDebitCreditPartyCol, getTransactionalTypeOpt, PdfFooter, getDebitCreditPartyFilterCol } from '../RechargeHistory/constant'
import { useTranslation } from '../../../../../i18n/I18nProvider'
import moment from 'moment'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import { GetRequest, PostRequest } from '../../../../common/api'
import { urls } from '../../../../common/constants'
import { getOwnChildBranches } from '../../../../../store/reports/reports_action'
import TablePaginationCustom from '../../../../common/TablePagination'
import * as mdt from '../../../../../components/common/modaltypes'
import BranchCreditDebitNote from '../BranchCreditDebitNote'
import { getPartyCreditDebitDetailsData } from '../../../../../store/Acounting/acounting_action'
import jsPDF from 'jspdf'
import { callAddFontRobotoBold } from '../../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../../common/font/Roboto-Medium-normal'
import autoTable from 'jspdf-autotable'
const DebitCreditParty = (props) => {
  const { translations } = useTranslation()
  const rdcn = translations?.rechargeDebitCreditNote || {}
  const cs = translations?.common || {}
  const debitCreditPartyCol = getDebitCreditPartyCol(translations)
  const debitCreditPartyFilterCol = getDebitCreditPartyFilterCol(translations)
  const transactionalTypeOpt = getTransactionalTypeOpt(translations)
  const {
    data,
    updateModal,
    getPartyCreditDebitDetailsData,
    updateAlertError
  } = props
  const [state, setState] = useState({
    generatePDF: false,
    load: false,
  })
  const { common, reports } = data
  const { generatePDF, load } = { ...state }
  const { loginData, RechargeList, showModal, modalType, RechargePaymentList, roleRights } = common
  const { ownChildBranches1, reportBranchList, } = reports
  const { intCompanyID, intBranchID } = loginData
  const [viewLimit, setViewLimit] = useState(false)
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [selTransType, setSelTransType] = useState(transactionalTypeOpt[0])
  const [sourceCityList, setSourceCityList] = useState([])
  const [selSourceCity, setSelSourceCity] = useState([])
  const [sourceBranchList, setSourceBranchList] = useState([])
  const [selSourceBranch, setSelSourceBranch] = useState()
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [page, setPage] = useState(0)
  const [totalNoOfRows, setTotalNoOfRows] = useState(0)
  const [tableData, setTableData] = useState([])
  const [showTable, setShowTable] = useState(true)
  const [resPartyCity, setResPartyCity] = useState([])
  const [updatedRes,setUpdatedRes]=useState([])
  useEffect(() => {
    const partyCity = resPartyCity.flatMap((party) => {
      const cityIds = party.CityID.split("~");
      const cityNames = party.PartyCitiesNames.split("~");
      return cityIds.map((id, index) => ({
        PartyID: party.PartyID,
        Party: party.Party,
        CityID: id,
        CityName: cityNames[index] || "",
      }));
    });
    setUpdatedRes(partyCity)
  }, [resPartyCity])
  useEffect(() => {
    const cities = updatedRes?.map(record => ({
      CityID: record.CityID,
      CityName: record.CityName,
    }));
    const cityList = removeDuplicatesFromArray(cities, 'CityID')
    const partyList = removeDuplicatesFromArray(updatedRes, 'PartyID')
    setSourceCityList([{ CityName: rdcn.allOption || 'All', CityID: 0 }, ...cityList])
    setSourceBranchList([{ Party: rdcn.allOption || 'All', PartyID: 0 }, ...partyList])
  }, [updatedRes])
  useEffect(() => {
    const loginCity = sourceCityList?.filter((val) => val?.CityID === loginData?.intBranchCityID)
    if (loginCity?.length > 0) {
      setSelSourceCity(loginCity[0])
    } else {
      setSelSourceCity(sourceCityList[0])
    }
  }, [sourceCityList])

  useEffect(() => {
    setSelSourceBranch(sourceBranchList[0])
  }, [sourceBranchList])
  useEffect(() => {
    if (!isEmpty(loginData)) {
      const obj = {
        intPartyID: 0,
        intCompanyID: 1,
        strPartyName: "",
        strContactPerson: "",
        intCityID: 0,
        intIsCreditParty: -1,
        intIsActive: -1,
        intIsDeleted: 0
      }
      PostRequest(urls.getPartyList, obj).then((res) => {
        if (res.status === 'Success') {
          setResPartyCity(res?.Data)
        }
      })
    }
  }, [loginData])
  useEffect(() => {
    if (sourceBranchList.length > 0) {
      setSelSourceBranch(sourceBranchList[0]); // Set to the 0th index of sourceBranchList
    }
  }, [sourceBranchList]);
  const handleLoadButton = () => {
    // setShowTable(false)
    // setIsPdfLoading(false)
    // if (selVehicle === '' || selVehicle === ' ') {
    //   updateAlertError({ show: true, msg: 'Please select Vehicle No', nextId: 'loadbtn' })
    // } else if (selInclGSTComm === '' || selInclGSTComm === ' ') {
    //   updateAlertError({ show: true, msg: 'Please select Incl. GST on Comm', nextId: 'Incl_GST_Comm' })
    // } else if (selOfflineBooking === '' || selOfflineBooking === ' ') {
    //   updateAlertError({ show: true, msg: 'Please select Offline Booking', nextId: 'Offline_Booking' })
    // } else if (selToPayHamali === '' || selToPayHamali === ' ') {
    //   updateAlertError({ show: true, msg: 'Please select To Pay Hamali', nextId: 'To_Pay_Hamali' })
    // } else {
    const body = {
      CompanyID: loginData?.intCompanyID,
      PartyID: selSourceBranch?.PartyID,
      TranDate: moment(fromDate).format('YYYY-MM-DD'),
      ToDate: moment(toDate).format('YYYY-MM-DD'),
      TranType: selTransType?.id === 0 ?'All':selTransType?.id === 1?'dr' : 'cr',
      CityID: selSourceCity?.CityID,
    }
    getPartyCreditDebitDetailsData(body).then((res) => {
      updateLoader(false)
      if (res.status === 'Success') {
        const data = res?.Data?.Table?.map((val, index) => ({ ...val, SN: index + 1, TranDate: moment(val?.TranDate).format('DD-MMM-YYYY HH:mm') }))
        setTableData(data || [])
        setTotalNoOfRows(2)
        // setShowTable(true)
      } else {
        updateAlertError({ show: true, msg: res?.ErrMessage, nextId: 'loadbtn' })
        // setShowTable(false)
      }
    })
    // }

  }
  const HeaderData = [
    {
      company: loginData?.strCompanyName,
      transType: selTransType?.name,
      city: selSourceCity?.CityName,
      branch: selSourceBranch?.Party,
      fromDate: moment(fromDate).format('YYYY-MM-DD'),
    },
  ]
  const printClick = (isSave) => {
    setShowTable(false)
    setState({ ...state, load: true, generatePDF: true })
    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])

    const pdfColumns = debitCreditPartyCol.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const HeaderColumns = debitCreditPartyFilterCol.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const doc = new jsPDF({ orientation: 'landscape', format: [1156, 1636], unit: 'px', compress: true, });
    var totalPagesExp = '{total_pages_count_string}'
    doc.setProperties({
      title: `${rdcn.debitCreditNoteForParty || 'Debit/Credit Note For Party'}.pdf`,
      subject: rdcn.debitCreditNoteForParty || 'Debit/Credit Note For Party',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })
    autoTable(doc, {
      margin: { top: 60, left: 30, right: 30, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns,
      body: HeaderData,
      columnStyles: {
        0: { fontSize: 18, valign: 'middle', font: 'Roboto', fontStyle: 'normal', cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0], },
        1: { fontSize: 18, valign: 'middle', font: 'Roboto', fontStyle: 'normal', cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0], },
        2: { fontSize: 18, valign: 'middle', font: 'Roboto', fontStyle: 'normal', cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0], },
        3: { fontSize: 18, valign: 'middle', font: 'Roboto', fontStyle: 'normal', cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0], },
        4: { fontSize: 18, valign: 'middle', font: 'Roboto', fontStyle: 'normal', cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0], },
      },
      theme: 'grid',
      startY: 120,
      headStyles: {
        fillColor: [191, 225, 255],
        textColor: [0, 0, 0],
        minCellHeight: 36,
        valign: 'middle',
        cellPadding: 12,
        fontSize: 18,
        font: 'Roboto',
        fontStyle: 'normal',
        lineWidth: 0.6,
      },
      didDrawPage: function (data) {
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(18).setFont('Roboto', 'bold')
        // doc.text(
        //   `Booking Date: ${moment(fromDate).format('DD-MMM-YYYY')}  To  ${moment(toDate).format('DD-MMM-YYYY')} `,
        //   data.settings.margin.left,
        //   150
        // )
        // doc.text(`Report View: Detailed`, doc.internal.pageSize.width - data.settings.margin.left, 150, 'right')
      },
    })
    autoTable(doc, {
      margin: { top: 120, left: 30, right: 30, bottom: 40 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      headStyles: {
        fillColor: [191, 225, 255],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        valign: 'middle',
        fontStyle: 'normal',
        font: 'Roboto',
        textColor: [0, 0, 0],
      },
      tableLineWidth: 0.6,
      columns: pdfColumns,
      body: tableData,
      styles: {
        lineWidth: [0, 0.2, 0, 0.2],
      },
      //---------------data of table-----------
      columnStyles: {
        0: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        1: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        2: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        3: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        4: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        5: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        6: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        7: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        8: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        9: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        10: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
      },
      theme: 'grid',
      // didParseCell: (data) => {
      //     crdeitDrawCellDetail(data)
      // },
      didDrawPage: function (data) {
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(26).setFont('Roboto', 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text(rdcn.cargoSystemDebitCreditNoteParty || 'Cargo System | Debit/CreditNote Party', 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(22).setFont('Roboto', 'bold')
        doc.text(`${cs.companyName || 'Company Name'} :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
        PdfFooter(data, loginData, totalPagesExp, translations)
      },
      // showHead: 'never',
    })
    doc.setFont('Roboto')
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      doc.save(`${rdcn.debitCreditNoteForParty || 'Debit/Credit Note For Party'} ${new Date().getTime()}.pdf`)
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        document.getElementById('branchRechargeHistory').data = doc.output('datauristring', `${rdcn.debitCreditNoteForParty || 'Debit/Credit Note For Party'}.pdf`)
        // focusElemnt('backBtn')
      }, 2000)
    } else {
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        document.getElementById('branchRechargeHistory').data = doc.output('datauristring', `${rdcn.debitCreditNoteForParty || 'Debit/Credit Note For Party'}.pdf`)
        // focusElemnt('backBtn')
      }, 2000)
    }
  }
  const InsideRowContent = ({ item, index }) => {
    return (
      <TableRow className="receivedTr" key={index}>
        <>
          <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: "left", fontSize: "12px" }}>{item?.SN}</TableCell>
          <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: "left", fontSize: "12px" }}>{item.TranDate} </TableCell>
          <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: "left", fontSize: "12px" }}>{item.CompanyId} </TableCell>
          <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: "left", fontSize: "12px" }}>{item?.CompanyName} </TableCell>
          <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: "left", fontSize: "12px" }}>{item?.PartyId}</TableCell>
          <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: "left", fontSize: "12px" }}>{item?.Party}</TableCell>
          <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: "left", fontSize: "12px" }}>{item?.PartyCity}</TableCell>
          <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: "left", fontSize: "12px" }}>{item?.TransactionType}</TableCell>
          <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: "right", fontSize: "12px" }}>{item?.TransactionAmt}</TableCell>
          <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: "left", fontSize: "12px" }}>{item?.Remark}</TableCell>
          <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: "left", fontSize: "12px" }}>{item?.RequestedBy}</TableCell>
        </>
      </TableRow>
    )
  }
  const clickElement = (elementID) => {
    elementID && document.getElementById(elementID) && document.getElementById(elementID).click()
  }
  const selectedCity = (val) => {
    setSelSourceCity(val)
    let result = updatedRes?.filter((obj) => obj.CityID === val.CityID || val?.CityID === 0 || obj.PartyID === 0)
    setSourceBranchList([{ PartyID: 0, Party: rdcn.allOption || 'All' }, ...result])
  }
  return (
    <>
      {
        showTable ?
          <>
            <Grid container className='reportButton' sx={{ display: 'flex', flexWrap: 'nowrap', gap: '16px', padding: '12px 15px 4px 15px' }}>
              <Grid item md={1.2}>
                <Item sx={{ ...sx.itemsx }} className="input--container">
                  <DropDownOA
                    id={'selectCompany'}
                    label={rdcn.selectCompany || 'Select Company'}
                    defaultvalue={loginData.strCompanyName}
                    disabled={true}
                    // minWidth="10%"
                    width="100%"
                  />
                </Item>
              </Grid>
              <Grid item md={1.3}>
                <Item sx={{ ...sx.itemsx }} className="input--container">
                  <DropDownOA
                    id={'transactionalType'}
                    label={rdcn.transactionType || 'Transaction Type'}
                    data={transactionalTypeOpt}
                    defaultvalue={selTransType?.name}
                    idKey={`id`}
                    dataKey={`name`}
                    onSelect={(val) => {
                      setSelTransType(val)
                    }}
                    isObjArr={true}
                    searchPlaceholder={rdcn.searchByTransactionType || 'Search By Transaction Type'}
                    width="100%"
                  // nextId={id.srcBranch}
                  // prevId={id.stateId}
                  // resetFlag={resetFlag || resetCity}
                  // disabled={disableBtn}
                  />
                </Item>
              </Grid>
              <Grid item md={1.5}>
                <Item sx={{ ...sx.itemsx }} className="input--container">
                  <DropDownOA
                    id={'branchCity'}
                    label={(rdcn.partyCity || 'Party City').replace('\n', ' ')}
                    data={sourceCityList}
                    defaultvalue={selSourceCity?.CityName}
                    idKey={`CityID`}
                    dataKey={`CityName`}
                    onSelect={(val) => {
                      selectedCity(val)
                    }}
                    isObjArr={true}
                    searchPlaceholder={rdcn.searchByPartyCity || 'Search By Party City'}
                    width="100%"
                  // nextId={id.srcBranch}
                  // prevId={id.stateId}
                  // resetFlag={resetFlag || resetCity}
                  // disabled={disableBtn}
                  />
                </Item>
              </Grid>
              <Grid item md={1.5}>
                <Item sx={{ ...sx.itemsx }} className="input--container">
                  <DropDownOA
                    id={'partyName'}
                    label={(rdcn.partyName || 'Party Name').replace('\n', ' ')}
                    data={sourceBranchList}
                    defaultvalue={selSourceBranch?.Party || ''}
                    idKey={`PartyID`}
                    dataKey={`Party`}
                    onSelect={(val) => {
                      // setIsExpanded(false)
                      setSelSourceBranch(val)
                    }}
                    isObjArr={true}
                    searchPlaceholder={rdcn.searchByPartyName || 'Search By Party Name'}
                    width="100%"
                  // nextId={id.creditUsageSplitButton}
                  // prevId={id.srcCity}
                  // resetFlag={resetFlag || resetCity}
                  // disabled={disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 0}
                  />
                </Item>
              </Grid>
              <Grid item md={1.3}>
                <Item sx={{ ...sx.itemsx }} className="input--container bookingDatePicker">
                  <Datepicker
                    label={rdcn.transactionFromDate || 'Transaction From Date'}
                    // name={'from_date'}
                    id={'FromDate'}
                    // value={fromDate}
                    dateChange={(date) => {
                      setFromDate(date)
                      // focusElemnt(id.toDate)
                    }}
                    width="100%"
                  // startDate={'2022-01-01'}
                  // //startDate={subtractDaysFromDate(moment().format('YYYY-MM-DD'), 365)} //will return previous 1 year date
                  // endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 0)} //will return future 1 year date
                  />
                </Item>
              </Grid>
              <Grid item md={1.3}>
                <Item sx={{ ...sx.itemsx }} className="input--container bookingDatePicker">
                  <Datepicker
                    label={rdcn.transactionToDate || 'Transaction To Date'}
                    // name={'from_date'}
                    id={'toDate'}
                    // value={fromDate}
                    dateChange={(date) => {
                      setToDate(date)
                      // focusElemnt(id.toDate)
                    }}
                    width="100%"
                  // startDate={'2022-01-01'}
                  // //startDate={subtractDaysFromDate(moment().format('YYYY-MM-DD'), 365)} //will return previous 1 year date
                  // endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 0)} //will return future 1 year date
                  />
                </Item>
              </Grid>
              <Grid item md={0.8}>
                <Item sx={{ ...sx.itemsx }} className="">
                  <Button variant="contained" id="RechargeBtn" style={{ ...sx.fullHeight, ...sx.novp, padding: "5px 20px" }} className="btn btn-primary"
                    onClick={handleLoadButton}
                  // onKeyDown={(e) => {
                  //   navigation1(e, 'select_Payment_Mode', 'CANCEL')
                  // }}
                  >
                    {cs.load || 'Load'}
                  </Button></Item>
              </Grid>
              <Grid item md={2.1}>

                <Button id={"CANCEL"} variant="outlined" className="receiveitembtn"
                  onClick={() => { updateModal(true, mdt.branchCreditDebitNote) }}
                  // onKeyDown={(e) => {
                  //   navigation1(e, 'RechargeBtn', 'choose_Receipt')
                  // }}
                  style={{ width: '100%' }}
                >
                  {rdcn.raiseDebitCreditNote || 'RAISE DEBIT/CREDIT NOTE'}
                </Button>
              </Grid>
              <Grid item md={0.8}>
                <Button id={"CANCEL"} variant="outlined" sx={{ width: '100%' }} className="receiveitembtn"
                  onClick={() => printClick(false)}
                  // onKeyDown={(e) => {
                  //   navigation1(e, 'RechargeBtn', 'choose_Receipt')
                  // }}
                  style={{ width: '100%' }}
                >
                  {rdcn.printUpper || 'PRINT'}
                </Button>
              </Grid>
              <Grid item md={0.8}>
                <Box >
                  <Button id='view-xls-button' variant="outlined" sx={{ width: '100%', fontSize: '16px', color: '#fe5200' }} className="receiveitembtn"
                    onClick={(e) => { clickElement('xls-buttons') }}
                    // onKeyDown={(e) => {
                    //   navigation1(e, 'RechargeBtn', 'choose_Receipt')
                    // }}
                    style={{ width: '100%' }}
                  >
                    {rdcn.excel || 'EXCEL'}
                  </Button>
                  <ReactHtmlTableToExcel
                    id="xls-buttons"
                    table="tables"
                    filename={rdcn.debitCreditNoteForParty || 'Debit/Credit Note For Party'}
                    sheet="sheet 1"
                    buttonText={rdcn.exportAsExcel || 'EXPORT AS EXCEL'}
                    className="excel-button"
                  />
                </Box>
              </Grid>
            </Grid>
            {
              showTable ? <>
                <Box sx={{ padding: '12px 15px 4px 15px' }}>
                  <TableContainer className="scrollBlue" component={Paper} style={{ overflowX: 'auto', width: '100%', maxHeight: '45vh' }}>
                    <Table style={{ width: '100%' }} className="table1" size="small" aria-label="a dense table">
                      <TableHead style={{ position: `sticky`, top: `0`, background: `white` }}>
                        <TableRow style={{ borderRadius: "10px 10px 10px 10px" }}>
                          {debitCreditPartyCol?.map((item, i) => (
                            <TableCell key={i} style={{ textAlign: item.align, width: item.minWidth, color: "#444444", backgroundColor: "#BFE1FF",fontSize:'12px' }}>
                              {item?.headerName}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      {tableData?.length < 1 ? (
                        <TableBody>
                          <TableRow>
                            <TableCell colSpan={11}>
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  marginTop: '20px',
                                  marginBottom: '20px',
                                  color: 'red',
                                  fontSize: '14px',
                                }}
                              >
                                <span>{rdcn.noResultsFoundForFilters || 'No Results Found For The Selected Filters.'}</span>
                              </div>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      ) : (
                        <TableBody className="filter-data-row" style={{ border: "none" }}>
                          {(
                            rowsPerPage > 0
                              ? tableData.slice(
                                page * rowsPerPage,
                                page * rowsPerPage + rowsPerPage
                              ).map((item, index) => (
                                <InsideRowContent item={item} index={index} key={index} fontVal={'12px'} />
                              ))
                              : tableData?.map((item, index) => (
                                <InsideRowContent item={item} index={index} key={index} fontVal={'12px'} />
                              ))
                          )}
                        </TableBody>
                      )}
                    </Table>
                    <Table id='tables' style={{ width: '100%', display: 'none' }} className="table1" size="small" aria-label="a dense table">
                      <TableHead style={{ position: `sticky`, top: `0`, background: `white`, display: 'none' }}>
                        <TableRow>
                          <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '500', textAlign: 'left' }} colSpan={6}>
                            <h3 style={{ paddingLeft: '17px' }}>{rdcn.reportForDebitCreditNoteParty || 'Report For: Debit/CreditNote Party -'}</h3>
                          </TableCell>
                          <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '500', textAlign: 'right' }} colSpan={5}>
                            <h3 style={{ paddingLeft: '17px' }}>{cs.companyName || 'Company Name'} : {loginData.strCompanyName}</h3>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell colSpan={11}></TableCell>
                        </TableRow>
                        <TableRow style={{ borderRadius: "10px 10px 10px 10px" }}>
                          {debitCreditPartyFilterCol?.map((item, i) => (
                            <TableCell key={i} colSpan={item.colSpan} style={{ textAlign: item.align, width: item.minWidth, color: "#444444", backgroundColor: "#BFE1FF", whiteSpace: 'pre-line' }}>
                              {item?.headerName}
                            </TableCell>
                          ))}
                        </TableRow>
                        {HeaderData.map((data, i) => (
                          <TableRow key={i} style={{ borderRadius: "10px" }}>
                            {debitCreditPartyFilterCol.map((col, j) => (
                              <TableCell
                                colSpan={col.colSpan}
                                key={j}
                                style={{
                                  textAlign: col.align,
                                  width: col.minWidth,
                                  color: "#444444",
                                  backgroundColor: "#F5F5F5",
                                  whiteSpace: "pre-line",
                                }}
                              >
                                {data[col.field]}
                              </TableCell>
                            ))}
                          </TableRow>
                        ))}
                      </TableHead>
                      <TableHead style={{ position: `sticky`, top: `0`, background: `white` }}>
                        <TableRow style={{ borderRadius: "10px 10px 10px 10px" }}>
                          {debitCreditPartyCol?.map((item, i) => (
                            <TableCell key={i} style={{ textAlign: item.align, width: item.minWidth, color: "#444444", backgroundColor: "#BFE1FF" }}>
                              {item?.headerName}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      {tableData?.length < 1 ? (
                        <TableBody>
                          <TableRow>
                            <TableCell colSpan={11}>
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  marginTop: '20px',
                                  marginBottom: '20px',
                                  color: 'red',
                                  fontSize: '14px',
                                }}
                              >
                                <span>{rdcn.noResultsFoundForFilters || 'No Results Found For The Selected Filters.'}</span>
                              </div>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      ) : (
                        <TableBody className="filter-data-row" style={{ border: "none" }}>
                          {(
                            rowsPerPage > 0
                              ? tableData.slice(
                                page * rowsPerPage,
                                page * rowsPerPage + rowsPerPage
                              ).map((item, index) => (
                                <InsideRowContent item={item} index={index} key={index} fontVal={'12px'} />
                              ))
                              : tableData?.map((item, index) => (
                                <InsideRowContent item={item} index={index} key={index} fontVal={'12px'} />
                              ))
                          )}
                        </TableBody>
                      )}
                    </Table>
                  </TableContainer>
                  <TablePaginationCustom totRowCount={tableData?.length} rowsPerPageOptions={[10, 20, 50, 100, 200, 500]} rowsPerPage={rowsPerPage} page={page} handleChangePage={(event, newPage) => {
                    setPage(newPage);
                    //  handleLoadButton(newPage, rowsPerPage)
                  }} handleChangeRowsPerPage={(event) => {
                    setRowsPerPage(parseInt(event.target.value, 10));
                    setPage(0);
                    // handleLoadButton(0, parseInt(event.target.value, 10))
                  }} />
                </Box></> : null
            }
          </> : <>
            <Box>
              <Button
                style={{ border: '1px solid #fe5200', color: '#fe5200' }}
                id="backBtn"
                variant="outlined"
                className="userWisereporttembtn"
                onClick={() => (setShowTable(true))}
              >
                {cs.back || 'Back'}
              </Button>
            </Box>
            <>
              {generatePDF ? <div style={{ textAlign: 'center' }} className={'generatePDF'}>{cs.pdfGenerationMsg || 'Generating PDF....'}</div> : ''}
              {load ? (
                <object
                  id="branchRechargeHistory"
                  type="application/pdf"
                  width={'100%'}
                  height="440"
                  title="MTLPL -Cargo System - After Transfer Summary Report"
                  aria-label="MTLPL -Cargo System - After Transfer Summary Report"
                  style={{ marginTop: '10px', textAlign: 'center' }}
                ></object>
              ) : (
                ''
              )}
            </>
          </>
      }
      {showModal && mdt.branchCreditDebitNote === modalType && (
        <BranchCreditDebitNote />
      )}
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
  updateModal,
  getOwnChildBranches,
  getPartyCreditDebitDetailsData,
  updateAlertError
}
export default connect(mapStateToProps, mapDispatchToProps)(DebitCreditParty)
